var _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _g2, _rect, _path, _g3, _rect2, _path2, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 195,
    viewBox: "0 0 150 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_769_19838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 8.33325C8.3335 5.01954 11.0198 2.33325 14.3335 2.33325H118.751C120.35 2.33325 121.884 2.97214 123.01 4.10798L131.262 12.427L139.931 21.1856C141.043 22.309 141.667 23.8258 141.667 25.4065V166.245C141.667 169.558 138.981 172.245 135.667 172.245H14.3335C11.0198 172.245 8.3335 169.558 8.3335 166.245V8.33325Z",
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.0308,
    y1: 91.9636,
    x2: 117.153,
    y2: 91.9636,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56.0308,
    y1: 141.247,
    x2: 102.59,
    y2: 141.247,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56.0308,
    y1: 82.8071,
    x2: 117.153,
    y2: 82.8071,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56.0453,
    y1: 131.251,
    x2: 114.115,
    y2: 131.628,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 56.0308,
    y1: 101.12,
    x2: 95.7876,
    y2: 101.12,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 56.0308,
    y1: 151.481,
    x2: 107.996,
    y2: 151.481,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 36.1113,
    y1: 27.6173,
    x2: 67.0715,
    y2: 27.6173,
    stroke: "#031A6B",
    strokeOpacity: 0.5,
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 34.6113,
    y1: 42.0969,
    x2: 117.212,
    y2: 42.0969,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 34.6113,
    y1: 51.1431,
    x2: 79.8834,
    y2: 51.1431,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_769_19838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.465 22.3566L141.488 23.3578L120.463 2.33339L121.465 22.3566Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.3237,
    y: 76.282,
    width: 11.4457,
    height: 11.4457,
    rx: 4.5,
    fill: "#4EA699"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_769_19838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 74,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.416 74.3744H47.677V89.6354H32.416V74.3744Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_769_19838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1088 84.5802L43.6551 80.0179L42.908 79.2705L39.1088 83.0701L37.2329 81.2102L36.4858 81.9572L39.1088 84.5802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1088 84.5802L43.6551 80.0179L42.908 79.2705L39.1088 83.0701L37.2329 81.2102L36.4858 81.9572L39.1088 84.5802Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3237,
    y: 123.591,
    width: 11.4457,
    height: 11.4457,
    rx: 4.5,
    fill: "#4EA699"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_769_19838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 121,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.416 121.684H47.677V136.945H32.416V121.684Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_769_19838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1088 131.889L43.6551 127.327L42.908 126.58L39.1088 130.379L37.2329 128.519L36.4858 129.266L39.1088 131.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1088 131.889L43.6551 127.327L42.908 126.58L39.1088 130.379L37.2329 128.519L36.4858 129.266L39.1088 131.889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_769_19838",
    x: 0.833497,
    y: 2.33325,
    width: 148.333,
    height: 192.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.614167 0 0 0 0 0.614167 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_769_19838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_769_19838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_769_19838",
    x: 115.963,
    y: 0.833374,
    width: 30.0244,
    height: 30.0244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_769_19838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_769_19838",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer3);
export default __webpack_public_path__ + "static/media/Layer_3.b82159238c78d28863993caacbf6c107.svg";
export { ForwardRef as ReactComponent };